import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { AppLayout } from './layout/AppLayout';
import { LoadingSkeleton } from './ui/LoadingSkeleton';
import { Card } from './ui/Card';

export function ProtectedRoute() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const isLoading = useAuthStore((s) => s.isLoading);

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-surface">
        <Card padding="lg" className="w-full max-w-md">
          <LoadingSkeleton lines={4} />
        </Card>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return <AppLayout />;
}
